import { firestore, storageRef } from "./index"

class Counter {
	ref
	data
	query

	constructor(collectionName) {
		this.query = firestore
			.collection('counters')
			.doc(collectionName)
		this.initialize()
	}

	async initialize() {
		let snapshot = await this.query.get()
		if (!snapshot.exists) {
			await this.query.set({ total: 0 })
			snapshot = await this.query.get()
		}
		this.data = snapshot.data()
		this.ref = snapshot.ref
	}

	get() {
		return this.data
		// try {
		// 	this.data = (await this.query.get()).data()
		// 	return [false, this.data]
		// }
		// catch (error) { return [error] }
	}

	async increment() {
		this.data.total += 1
		await this.ref.update(this.data)
	}

	async decrement() {
		this.data.total -= 1
		await this.ref.update(this.data)
	}
}

export const createAPI = (basePATH) => {

	const refs = new Map()
	const collection = firestore.collection(basePATH)

	let query = collection

	const counter = new Counter(basePATH)

	const toDoc = docSnap => ({
		id: docSnap.id,
		...docSnap.data()
	})

	const toArray = (snapshot) => {
		const items = []
		snapshot.forEach(docSnap => {
			if (!refs.has(docSnap.id)) {
				refs.set(docSnap.id, docSnap.ref)
			}
			items.push(toDoc(docSnap))
		})
		return items
	}

	const get = (params = {}) => {
		const { perPage = 10, page = 1 } = params
		return new Promise(resolve => {
			return query
				.orderBy("updatedAt")
				.startAt(perPage * page)
				.limit(perPage)
				.get()
				.then(snap => resolve([null, {
					...counter.data,
					data: toArray(snap)
				}]))
				.catch(err => resolve([err]))
		})
	}

	const update = async (id, data) => {
		try {
			const updatedData = {
				...data,
				updatedAt: Date.now()
			}

			const docRef = refs.get(id)
			if (docRef) await docRef.update(updatedData)

			else {
				const docSnapshot = await collection.doc(id).get()
				if (!docSnapshot.exists) return [{ message: 'Document not found' }]

				refs.set(docSnapshot.id, docSnapshot.ref)
				await docSnapshot.ref.update(updatedData)
			}
			return [false, updatedData]
		}
		catch (error) { return [error] }
	}

	const remove = async (id) => {
		try {
			let res

			const docRef = refs.get(id)
			if (docRef) res = await docRef.delete()

			else {
				const docSnapshot = await collection.doc(id).get()
				if (!docSnapshot.exists) return [{ message: 'Document not found' }]

				res = await docSnapshot.ref.delete()
			}
			refs.delete(id)
			return [false, res]
		}
		catch (error) { return [error] }
	}

	const onAdded = async (callback) => {
		collection
			.orderBy('createdAt', 'desc')
			.limit(1)
			.onSnapshot(querySnapshot => {
				if (querySnapshot.empty) return
				const docSnapshot = querySnapshot.docs[0]
				refs.set(docSnapshot.id, docSnapshot.ref)
				callback(toDoc(docSnapshot))
			})
	}

	const onUpdated = async (callback) => {
		collection
			.orderBy('updatedAt', 'desc')
			.limit(1)
			.onSnapshot(querySnapshot => {
				if (querySnapshot.empty) return
				const docSnapshot = querySnapshot.docs[0]
				refs.set(docSnapshot.id, docSnapshot.ref)
				callback(toDoc(docSnapshot))
			})

	}

	return {
		get,
		remove,
		update,
		onAdded,
		onUpdated,
		async uploadFiles(files, progressCallback) {
			return new Promise(resolve => {
				const documents = []
				if (!files.length) resolve(documents)
				files = Array.isArray(files) ? files : [files]

				let uploaded = 0
				for (const file of files) {
					const filename = `Documento_${Math.random().toString(36).slice(-10)}.${file.name.split('.').pop()}`
					const uploadTask = storageRef.child(`/${basePATH}/${filename}`).put(file)
					uploadTask.on('state_changed',
						//Progress
						() => { },
						// Error
						() => { uploaded += 1 },
						// Done
						() => {
							uploadTask.snapshot.ref
								.getDownloadURL()
								.then((downloadURL) => {
									const doc = {
										name: filename,
										url: downloadURL,
										originalName: file.name,
									}
									documents.push(doc)
									progressCallback && progressCallback(doc, file)

									uploaded += 1

									if (uploaded === files.length) {
										resolve(documents)
									}
								})
						}
					)
				}
			})
		},
		where(...args) {
			query = query.where(...args)
			return this
		},
		onSnapshot(callback) {
			return query.onSnapshot(qSnap => {
				const docs = toArray(qSnap)
				callback([null, docs])
			})
		},
		getById(id) {
			return new Promise(resolve => {
				return query.doc(id).get()
					.then(snap => resolve([null, toDoc(snap)]))
					.catch(err => resolve([err]))
			})
		},
		save(data) {
			return new Promise(resolve => {
				return collection
					.add({
						...data,
						createdAt: Date.now(),
						updatedAt: Date.now(),
					})
					.then(docRef => {
						counter.increment()
						resolve([null, docRef])
					})
					.catch(err => resolve([err]))
			})
		}
	}
}
